import React from 'react';

// Empty-state placeholder per shared-docs/ux-requirements.md and frontend-architecture.md.
// Replaces blank screens. Optional CTA via the `action` slot (typically a <Button />).
export default function EmptyState({ icon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 px-4">
      {icon && (
        <div className="text-4xl mb-3" aria-hidden="true">
          {typeof icon === 'string' ? icon : icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-gray-900 dark:text-night-text mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-gray-500 dark:text-night-muted max-w-sm">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
